import React from 'react';
import { Box } from '@mui/material';
import Header from '../../../components/Header';
import FooterTwo from '../../../components/Footer/index';
import AdmissionProcessMain from './AdmissionProcessMain';
import NpfTracking from '../../../components/NpfTracking';
import NpfWidget from '../../../components/NpfWidget';

const AdmissionProcess = () => {
    return (
        <Box sx={{ background: '#F8FAFC', minHeight: '100vh' }}>
            {/* NoPaperForms: dynamic tracking + enquiry widget */}
            <NpfTracking />
            <NpfWidget />
            <Header
                parentMenu='study'
                menuCategoryEnable='enable'
            />
            <AdmissionProcessMain />
            <FooterTwo />
        </Box>
    );
}

export default AdmissionProcess;

